import { FDStack } from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import MainContent
  from 'Views/Page/Content/Templates/CapitalizeRolloverWebviewStepTemplate/Content/MainContent/MainContent';
import ManualRolloverSectionPicker
  from 'Views/Page/Content/Templates/CapitalizeRolloverWebviewStepTemplate/Content/ManualRolloverSection/ManualRolloverSectionPicker';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import AccountDetailsSectionPicker
  from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate/Content/AccountDetailsSection/AccountDetailsSectionPicker';

const Layout = () => {
  return (
    <FDStack
      direction={'column'}
      spacing={3}
      paddingY={4}
      justifyContent={'center'}
    >
      <MetaField attr="title" />
      <LottieLoadingLayout>
        <AccountDetailsSectionPicker />
      </LottieLoadingLayout>
      <MainContent />
      <ManualRolloverSectionPicker />
      <MetaField attr={'disclaimer'} />
    </FDStack>
  );
};

Layout.defaultProps = {};

Layout.propTypes = {};

export default Layout;
